import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

const CKEY = "sus-customer-token";
export const getCustomerToken = () => localStorage.getItem(CKEY);
export const setCustomerToken = (t) => (t ? localStorage.setItem(CKEY, t) : localStorage.removeItem(CKEY));
api.interceptors.request.use((cfg) => {
  const t = getCustomerToken();
  if (t && !cfg.headers?.Authorization) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const signup = (body) => api.post("/account/signup", body).then((r) => r.data);
export const login = (body) => api.post("/account/login", body).then((r) => r.data);
export const logoutApi = () => api.post("/account/logout").then((r) => r.data);
export const googleLogin = (session_id) => api.post("/account/google", { session_id }).then((r) => r.data);
export const forgotPassword = (email) => api.post("/account/forgot", { email }).then((r) => r.data);
export const resetPassword = (body) => api.post("/account/reset", body).then((r) => r.data);
export const getMe = () => api.get("/account/me").then((r) => r.data);
export const updateMe = (body) => api.put("/account/me", body).then((r) => r.data);
export const getMyOrders = () => api.get("/account/orders").then((r) => r.data);
export const getMyPoints = () => api.get("/account/points").then((r) => r.data);
export const getMyActivity = () => api.get("/account/activity").then((r) => r.data);
export const getMyCodes = () => api.get("/account/codes").then((r) => r.data);
export const getRewards = () => api.get("/rewards").then((r) => r.data);
export const getPointsRules = () => api.get("/points-rules").then((r) => r.data);
export const redeemReward = (id) => api.post(`/account/rewards/${id}/redeem`).then((r) => r.data);
export const trackShare = (kind, ref) => api.post("/account/share", { kind, ref }).then((r) => r.data);
export const getBundles = () => api.get("/bundles").then((r) => r.data);
export const getBundle = (slug) => api.get(`/bundles/${slug}`).then((r) => r.data);
export const quoteCart = (body) => api.post("/checkout/quote", body).then((r) => r.data);
export const giftBalance = (code) => api.post("/gift-cards/balance", { code }).then((r) => r.data);
export const KIT_URL = `${process.env.REACT_APP_BACKEND_URL}/api/sotm/designer-kit.zip`;
export const KIT_PREVIEW = `${process.env.REACT_APP_BACKEND_URL}/api/sotm/designer-kit/preview.png`;
export const giftArt = (design, amount) => `${process.env.REACT_APP_BACKEND_URL}/api/gift-cards/art/${design}.png?amount=${amount}`;

export const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const shareImg = (id, kind, download) => `${API_BASE}/sotm/submissions/${id}/share/${kind}.png${download ? "?download=1" : ""}`;
export const shareLink = (s) => `${API_BASE}/share/sotm/${s.code || s.id}`;
export const getSotmSubmission = (ref) => api.get(`/sotm/submissions/${ref}`).then((r) => r.data);
export const joinWaitlist = (slug, body) => api.post(`/drops/${slug}/waitlist`, body).then((r) => r.data);
export const getProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getRelated = (slug) => api.get(`/products/${slug}/related`).then((r) => r.data);
export const getDrops = () => api.get("/drops").then((r) => r.data);
export const getDrop = (slug) => api.get(`/drops/${slug}`).then((r) => r.data);
export const getDropAccess = (slug, token) => api.get(`/drops/${slug}/access`, { params: { token } }).then((r) => r.data);
export const createRestockAlert = (slug, body) => api.post(`/products/${slug}/restock-alerts`, body).then((r) => r.data);
export const getPackPreview = () => api.get("/crew/pack-preview").then((r) => r.data);
export const getLookbook = () => api.get("/lookbook").then((r) => r.data);
export const getWall = () => api.get("/sotm/wall").then((r) => r.data);
export const getSettings = () => api.get("/settings").then((r) => r.data);
export const getSizeCharts = () => api.get("/size-charts").then((r) => r.data);
export const validateCart = (body) => api.post("/cart/validate", body).then((r) => r.data);
export const subscribe = (body) => api.post("/subscribers", body).then((r) => r.data);
export const getSotmGallery = () => api.get("/sotm/gallery").then((r) => r.data);
export const getSotmWinner = (slug) => api.get(`/sotm/winners/${slug}`).then((r) => r.data);
export const submitSotm = (form) => api.post("/sotm/submissions", form).then((r) => r.data);
export const createCheckout = (body) => api.post("/checkout", body).then((r) => r.data);
export const getCheckoutStatus = (sid) => api.get(`/checkout/status/${sid}`).then((r) => r.data);
export const getOrder = (id, session_id) => api.get(`/orders/${id}`, { params: { session_id } }).then((r) => r.data);
export const lookupOrder = (body) => api.post("/orders/lookup", body).then((r) => r.data);
export const voteSotm = (id, device_id) => api.post(`/sotm/submissions/${id}/vote`, { device_id }).then((r) => r.data);

export const errText = (e) => {
  const d = e.response?.data?.detail;
  if (!d) return "Something went sideways. Try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || String(x)).join(" ");
  return String(d);
};

export const deviceId = () => {
  let id = localStorage.getItem("sus-device-id");
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem("sus-device-id", id);
  }
  return id;
};

export const monthLabel = (m) => new Date(`${m}-15T12:00:00`).toLocaleDateString("en-CA", { month: "long", year: "numeric" });
export const torontoMonth = () => new Intl.DateTimeFormat("en-CA", { timeZone: "America/Toronto", year: "numeric", month: "2-digit" }).format(new Date());
